import { QueryClient } from '@tanstack/react-query'

const NO_RETRY_STATUS_CODES = [400, 401, 403]

function getStatusFromError(error: unknown): number | undefined {
  if (error && typeof error === 'object') {
    const err = error as { status?: number; response?: { status?: number } }
    return err.status ?? err.response?.status
  }
  return undefined
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const status = getStatusFromError(error)
        if (status !== undefined && NO_RETRY_STATUS_CODES.includes(status)) {
          return false
        }
        return failureCount < 3
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchOnMount: false,
    },
    mutations: {
      retry: (failureCount, error) => {
        const status = getStatusFromError(error)
        if (status !== undefined && NO_RETRY_STATUS_CODES.includes(status)) {
          return false
        }
        return failureCount < 1
      },
      retryDelay: 1000,
    },
  },
})
